/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, codec: NonNullable<unknown>, layout: NonNullable<unknown> }} Audio_Embed_Export_Stream_AudioInputs */



/**
* | output |
* | --- |
* | "Audio {index}: {codec}{layout}" |
*
* @param {Audio_Embed_Export_Stream_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_stream_audio = /** @type {((inputs: Audio_Embed_Export_Stream_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Stream_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Audio ${i?.index} : ${i?.codec}${i?.layout}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audio ${i?.index}: ${i?.codec}${i?.layout}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Audio ${i?.index}: ${i?.codec}${i?.layout}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Аудио ${i?.index}: ${i?.codec}${i?.layout}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Audio ${i?.index}: ${i?.codec}${i?.layout}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`音频 ${i?.index}：${i?.codec}${i?.layout}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オーディオ ${i?.index}: ${i?.codec}${i?.layout}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो ${i?.index}: ${i?.codec}${i?.layout}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Áudio ${i?.index}: ${i?.codec}${i?.layout}`)
	return /** @type {LocalizedString} */ (`Audio ${i?.index}: ${i?.codec}${i?.layout}`)
});